<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text mb-4"
          style="background: transparent" >
          <v-toolbar-title>Propostas Recebidas</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn flat icon color="primary" @click="recarregarPagina()">
              <v-icon>autorenew</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          hide-actions
          :hide-headers="!propostas.length"
          :pagination.sync="pagination"
          :items="propostas"
          :headers="postosHeader"
          class="elevation-1"
          :total-items="totalItems"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon color="teal" dark v-on="on" v-if="props.item.status==true">check_circle_outline</v-icon>
                  </template>
                  <span>Proposta Aceita.</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon color="primary" dark v-on="on" v-if="props.item.status==null">query_builder</v-icon>
                  </template>
                  <span>Aguardando Confirmação.</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon color="red" dark v-on="on" v-if="props.item.status==false">highlight_off</v-icon>
                  </template>
                  <span>Recusado.</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{props.item.identificacao}}</td>
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">{{props.item.rede ? 'ac_unit' : 'local_gas_station'}}</v-icon>
                  </template>
                  <span>{{props.item.rede ? 'Rede' : `Posto ${posto && posto.nome_fantasia}`}}</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{props.item.empresa.nome_fantasia}}</td>
              <td class="text-xs-center">{{props.item.data_abertura.substr(0, 10).split('-').reverse().join('/')}}</td>
              <td class="text-xs-right">
                <v-btn flat icon color="primary" @click="selecionarPosto(props.item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-right">
                <v-btn flat icon color="red" @click="verRecargas(props.item)">
                  <v-icon>attach_money</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog lazy width="450" v-model="dialogSubmeterProposta" :fullscreen="$vuetify.breakpoint.xs">
      <resp-proposta v-if="dialogSubmeterProposta" :proposta="propostaSelected" @fechar="dialogSubmeterProposta = false" @carregar="carregarPropostas"></resp-proposta>
    </v-dialog>
    <v-dialog lazy width="500" v-model="dialogSubmetePagamento" :fullscreen="$vuetify.breakpoint.xs">
      <resp-pagamento v-if="dialogSubmetePagamento" :proposta="propostaSelected" @fechar="dialogSubmetePagamento = false" @carregar="carregarPropostas"></resp-pagamento>
    </v-dialog>
    <v-dialog lazy width="500" v-model="dialogVisualizarComprovante" :fullscreen="$vuetify.breakpoint.xs">
      <resp-comprovante v-if="dialogVisualizarComprovante" :proposta="propostaSelected" @fechar="dialogVisualizarComprovante = false" @carregar="carregarPropostas"></resp-comprovante>
    </v-dialog>
    <v-dialog lazy width="500" v-model="dialogRecarga" :fullscreen="$vuetify.breakpoint.xs">
      <dialog-recarga v-if="dialogRecarga" :proposta="propostaSelected" @fechar="dialogRecarga = false" @carregar="carregarPropostas"></dialog-recarga>
    </v-dialog>
    <v-dialog lazy width="400" v-model="dialogVisualizarProposta" :fullscreen="$vuetify.breakpoint.xs">
      <v-card>
        <v-toolbar color="primary" dark>
            <v-toolbar-title>Dados da negociação</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div v-if="propostaSelected">
              <div class="headline text-xs-center mb-2"><b>{{propostaSelected.empresa.nome_fantasia}}</b></div>
              <v-flex xs12 class="text-xs-left pb-2 pt-2">Identificação: <b>{{propostaSelected.identificacao}}</b></v-flex>
              <v-flex xs12 class="text-xs-left pb-2 pt-2">Razão Social: <b>{{propostaSelected.empresa.razao_social}}</b></v-flex>
              <v-flex xs12 class="text-xs-left pb-2 pt-2">CNPJ: <b>{{propostaSelected.empresa.cnpj}}</b></v-flex>
              <v-flex xs12 class="text-xs-left pb-2 pt-2" v-if="propostaSelected.desconto !== null">
                {{propostaSelected.modelo_faturamento == 'prepago' ? 'Acréscimo' :'Desconto'}}: <b>{{propostaSelected.desconto}}%</b>
              </v-flex>
              <v-flex xs12 class="text-xs-left pt-2 pb-2" v-if="propostaSelected.status == true">Situação da Proposta:
                <b>{{propostaSelected.status == true ? 'Aceita': (propostaSelected.status == false ? 'Recusada' : 'Aguardando Resposta')}}</b>
              </v-flex>
              <v-flex xs12 class="text-xs-left pt-2 pb-2">
                Modelo Aceito:
                <b>{{propostaSelected.modelo_faturamento == 'prepago' ? " Pagamento pré-pago" : ''}}
                {{propostaSelected.modelo_faturamento == 'pospago' ? " Pagamento pós-pago" : ''}}
                {{propostaSelected.modelo_faturamento == 'presencial' ? " Pagamento no posto" : ''}}</b>
              </v-flex>
              <v-flex xs12 class="text-xs-left pt-2 pb-2" v-if="propostaSelected.modelo_faturamento == 'pospago'">
                Perido de pagamento: <b>{{propostaSelected.periodo === 0 ? 'Semanal' : propostaSelected.periodo === 1 ? 'Quinzenal' : 'Mensal'}}</b>
              </v-flex>
              <v-flex
                xs12
                class="text-xs-left pt-2 pb-2"
                v-if="propostaSelected.status_pagamento == true && propostaSelected.modelo_faturamento != 'presencial'"
              >
                Valor: <b>{{ (propostaSelected.modelo_faturamento === 'prepago' ? propostaSelected.valor_gasto : propostaSelected.valor) | currency({fractionCount: 2}) }}</b>
              </v-flex>
              <v-flex
                xs12
                class="text-xs-left pt-2 pb-2"
                v-if="propostaSelected.modelo_faturamento == 'prepago' && propostaSelected.status_pagamento == true"
              >
                Cashback: <b>{{ propostaSelected.cashback | currency({fractionCount: 2}) }}</b>
              </v-flex>
              <v-flex xs12 class="text-xs-left pt-2 pb-2">
                Para:
                <b>
                  <template v-if="propostaSelected.combustivel">
                    {{propostaSelected.combustivel.nome}}
                  </template>
                  <template v-else-if="propostaSelected.item">
                    {{propostaSelected.item.nome}}
                  </template>
                  <template v-else>
                    Todos os Combustíveis
                  </template>
                </b>
              </v-flex>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialogVisualizarProposta = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import RespProposta from '@/components/dialogs/RespostaProposta'
import RespPagamento from '@/components/dialogs/RespostaPagamento'
import RespComprovante from '@/components/dialogs/RespostaComprovante'
import DialogRecarga from '@/components/dialogs/DialogRecarga.vue'

export default {
  components: {
    RespProposta,
    RespPagamento,
    RespComprovante,
    DialogRecarga
  },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogSubmeterProposta: false,
      dialogSubmetePagamento: false,
      dialogVisualizarProposta: false,
      dialogVisualizarComprovante: false,
      dialogRecarga: false,
      propostaSelected: null,
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      totalItems: 0,
      dialog: false,
      propostas: [],
      postosHeader: [
        {
          text: '',
          align: 'left',
          sortable: false
        },
        {
          text: 'Identificação',
          value: 'identificacao',
          sortable: false
        },
        {
          text: 'Tipo de origem',
          align: 'left',
          sortable: false
        },
        {
          text: 'Remetente',
          align: 'left',
          sortable: false
        },
        {
          text: 'Data abertura',
          align: 'center',
          sortable: false
        },
        {
          text: 'Detalhes',
          align: 'right',
          sortable: false
        },
        {
          text: 'Recargas solicitadas',
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    if (this.ready) {
      this.carregarPropostas()
    }
  },
  watch: {
    posto (val) {
      if (val !== null && val !== undefined) {
        this.carregarPropostas()
      }
    },
    'pagination.page' (val) {
      if (val && this.propostas.length > 0) {
        this.carregarPropostas()
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    headers () {
      return this.$store.getters.headers
    },
    ready () {
      return this.headers && this.posto
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    carregarPropostas () {
      this.$store.dispatch('buscarPropostasDoPosto', {
        page: this.pagination.page,
        has_pagination: true
      }).then(json => {
        this.totalItems = json.count
        this.propostas = json.results
      })
    },
    selecionarPosto (proposta) {
      this.propostaSelected = proposta
      if (this.propostaSelected.data_resposta !== null) {
        this.dialogVisualizarProposta = true
      } else {
        this.dialogSubmeterProposta = true
      }
    },
    selecionarPostoPagamento (proposta) {
      this.propostaSelected = proposta
      if (this.propostaSelected.num_boleto || this.propostaSelected.chave_pix || this.propostaSelected.dados_bancarios) {
        this.dialogVisualizarComprovante = true
      } else {
        this.dialogSubmetePagamento = true
      }
    },
    verRecargas (proposta) {
      this.propostaSelected = proposta
      this.dialogRecarga = true
    },
    recarregarPagina () {
      document.location.reload(true)
    }
  }
}
</script>
